export default __webpack_public_path__ + "static/media/abcf-logo.b1168a63.jpeg";